/**
 * Creazione bozza FIR digitale — delega al wizard guidato.
 */
import { FirWizardDialog } from "@/components/FirWizardDialog";
import type { DraftItem } from "@/api/client";

export function NuovoFormularioDialog({
  open,
  onOpenChange,
  onCreated,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreated?: (d: DraftItem) => void;
}) {
  return (
    <FirWizardDialog
      open={open}
      onOpenChange={onOpenChange}
      onCreated={onCreated}
      stayOnPage
    />
  );
}
